import React, { useCallback } from 'react';
import Div from '../Div';
import Images from '../Image';
import classNames from 'classnames';
import Button from '../Button';
import { useProfileContext } from '@/context/profileContext';
import { useRouter } from 'next/router';
import { useAppConfigContext } from '@/context/AppContext';
import dlv from 'dlv';

type PersonalisedWidgetProps = {
  dataTestId: string;
  image: any;
  title: string;
  subTitle?: string;
  index: number;
  icon: any;
  ctas: any[];
};

function PersonalisedWidget(props: PersonalisedWidgetProps) {
  const { dataTestId, index, title, icon, subTitle, ctas } = props;
  const { href, target, size } = ctas[0] ?? {};
  const { state: profile } = useProfileContext();
  const { dispatch: appConfigDispatch } = useAppConfigContext();
  const router = useRouter();
  const onClick = useCallback(() => {
    if (profile.isLoggedIn) {
      return router.push({
        pathname: href,
      });
    }
    appConfigDispatch.toggleLoginModal(href);
  }, [appConfigDispatch, href, profile.isLoggedIn, router]);

  const { alternativeText, url, width, height } = dlv(icon, 'data.attributes') ?? {};

  return (
    <Button theme="none" target={target} size={size} onClick={onClick} dataTestId={dataTestId}>
      <Div className="flex rounded-cs bg-text-cs-primary shadow-subtle justify-between">
        <Div className="flex flex-col gap-s2 justify-start text-left pt-s4 pl-s5">
          <Div className="w-18 text-cti-primary text-callout-normal flex flex-wrap">{title}</Div>
          <Div className="text-cu-positive text-body-xs block ">{subTitle}</Div>
        </Div>

        <Images alt={alternativeText} src={url} width={64} height={88} />
      </Div>
    </Button>
  );
}

export default PersonalisedWidget;
